export default "__VITE_ASSET__BYodsBT4__"